/**
 * Which grid you were last looking at (`080-calendar.md` §5).
 *
 * > "The week/month toggle persists across sessions in `localStorage` (`calendar.lastView`).
 * > It is a **UI preference, not a settings key** — do not add it to `100-settings.md`; it is
 * > not worth a round-trip."
 *
 * The agenda is not one of the values: it is the DEFAULT screen, not an alternate (`080` §3).
 */
export type GridView = 'week' | 'month';

const STORAGE_KEY = 'rn.calendar.lastView';

export function rememberView(view: GridView): void {
  localStorage.setItem(STORAGE_KEY, view);
}

export function lastView(): GridView {
  return localStorage.getItem(STORAGE_KEY) === 'week' ? 'week' : 'month';
}
